import { QueryClient } from "@tanstack/react-query";

import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Our HttpClient already retries requests
      retry: false,

      // Default stale time of 5 minutes
      staleTime: 1000 * 60 * 5,
    },
    mutations: {
      onError: (err, variables) => {
        ErrorMonitoringService.captureError(err, { variables });
      },
    },
  },
});
